import TEXT_TO_VIDEO_CHECK_LIST from '@anm/data/textToVideoCheckList';

const isValidText = (text: string) => TEXT_TO_VIDEO_CHECK_LIST.every(({ pattern }) => pattern.test(text));

export default isValidText;
